import { render, staticRenderFns } from "./NhstResetPassword.vue?vue&type=template&id=ce38159a"
import script from "./NhstResetPassword.vue?vue&type=script&lang=js"
export * from "./NhstResetPassword.vue?vue&type=script&lang=js"
import style0 from "./NhstResetPassword.vue?vue&type=style&index=0&id=ce38159a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports